(function(){
  function getCurrency(){
    return (window.ShopMeta && ShopMeta.currency) || undefined;
  }
  function getGiftWrapId(){
    return (window.ShopMeta && ShopMeta.gift_wrap_id) || null;
  }
  async function fetchCart(){
    const res = await fetch('/cart.js', { credentials: 'same-origin' });
    return await res.json();
  }
  function dlPush(obj){
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(obj);
    console.log(`[DL PUSH] ${obj.event}:`, obj);
  }

  /* view_item_list */
  (function setupViewItemList(){
    const LIST_EL = document.getElementById('ProductsList');
    if (!LIST_EL) return;

    const LIST_ID = (window.__COLLECTION_ID__) || null;
    const LIST_NAME =
      document.querySelector('.collection .hd2, .collection h1, .collection .h1')?.textContent?.trim()
      || document.title.replace(/ *–.*$/,'')
      || 'Collection';
    const CURRENCY = getCurrency();

    const sentIds = new Set();
    let nextIndex = 0;

    function mapCard(el, idx){
      const pid = el.getAttribute('data-product-id');
      if (!pid || sentIds.has(pid)) return null;
      sentIds.add(pid);

      return {
        item_id: Number(pid),
        item_name: el.getAttribute('data-product-title'),
        item_brand: el.getAttribute('data-product-vendor') || undefined,
        item_category: el.getAttribute('data-product-type') || undefined,
        item_variant: undefined,
        price: Number(el.getAttribute('data-product-price')),
        currency: CURRENCY,
        index: idx
      };
    }

    function pushItems(items){
      if (!items.length) return;
      const payload = {
        event: 'view_item_list',
        ecommerce: {
          item_list_id: LIST_ID,
          item_list_name: LIST_NAME,
          items
        }
      };
      dlPush(payload);
    }

    (function initBatch(){
      const cards = LIST_EL.querySelectorAll('.card[data-product-id]');
      const items = [];
      cards.forEach((el) => {
        const it = mapCard(el, nextIndex);
        if (it) { items.push(it); nextIndex++; }
      });
      pushItems(items);
    })();

    const mo = new MutationObserver((mutations) => {
      const newItems = [];
      mutations.forEach((m) => {
        m.addedNodes.forEach((node) => {
          if (node.nodeType !== 1) return;

          if (node.classList?.contains('card') && node.hasAttribute('data-product-id')) {
            const it = mapCard(node, nextIndex);
            if (it) { newItems.push(it); nextIndex++; }
          }

          const innerCards = node.querySelectorAll?.('.card[data-product-id]');
          if (innerCards && innerCards.length) {
            innerCards.forEach((el) => {
              const it = mapCard(el, nextIndex);
              if (it) { newItems.push(it); nextIndex++; }
            });
          }
        });
      });
      pushItems(newItems);
    });
    mo.observe(LIST_EL, { childList: true, subtree: true });

    const container = document.getElementById('ProductGridContainer');
    if (container) {
      const moContainer = new MutationObserver(() => {
        const freshList = document.getElementById('ProductsList');
        if (freshList && freshList !== LIST_EL) {
          mo.disconnect();
          sentIds.clear();
          nextIndex = 0;
          const items = [];
          freshList.querySelectorAll('.card[data-product-id]').forEach((el) => {
            const it = mapCard(el, nextIndex);
            if (it) { items.push(it); nextIndex++; }
          });
          pushItems(items);
          mo.observe(freshList, { childList: true, subtree: true });
        }
      });
      moContainer.observe(container, { childList: true, subtree: true });
    }
  })();

/* view_cart (cart page) */
(function setupCartPageView(){
  const isCartPage = /\/cart(?:\/)?(?:\?|$)/.test(location.pathname);
  if (!isCartPage) return;

  const CURRENCY = getCurrency();

  (async function pushCart(){
    try{
      const cart = await fetchCart();
      if (!cart?.items?.length) return;

      const gw = getGiftWrapId();
      const items = cart.items
        .filter(i => !(gw && Number(i.id) === Number(gw)))
        .map(i => ({
          item_id: i.product_id,
          item_name: i.product_title,
          item_variant: i.variant_title,
          quantity: i.quantity,
          price: i.final_price / 100,
          currency: CURRENCY,
          item_category: i.product_type || undefined
        }));

      if (!items.length) return;

      dlPush({
        event: 'view_cart',
        ecommerce: {
          items,
          currency: CURRENCY
        }
      });
    } catch (e) {}
  })();
})();

/* view_cart (cart-drawer) */
(function setupDrawerViewOnButtonClick(){
  const drawerButton = document.querySelector('a.cart-drawer-button[aria-controls="CartDrawer"]');
  const drawer = document.getElementById('CartDrawer');
  if (!drawerButton || !drawer) return;

  const CURRENCY = getCurrency();
  let lastSentAt = 0;

  async function pushViewCart(){
    try {
      const now = Date.now();
      if (now - lastSentAt < 300) return;

      const cart = await fetchCart();
      if (!cart?.items?.length) return;

      const gw = getGiftWrapId();
      const items = cart.items
        .filter(i => !(gw && Number(i.id) === Number(gw)))
        .map(i => ({
          item_id: i.product_id,
          item_name: i.product_title,
          item_variant: i.variant_title,
          item_category: i.product_type || undefined,
          quantity: i.quantity,
          price: i.final_price / 100,
          currency: CURRENCY
        }));

      if (!items.length) return;

      lastSentAt = now;

      dlPush({
        event: 'view_cart',
        ecommerce: {
          items,
          currency: CURRENCY
        }
      });
    } catch (e) {
      console.warn('view_cart error:', e);
    }
  }

  drawerButton.addEventListener('click', () => {
    setTimeout(() => {
      if (!drawer.hasAttribute('hidden')) {
        pushViewCart();
      }
    }, 150);
  });
})();

  /* remove_from_cart */
  (function setupRemoveFromCart(){
    function toGaItem(item){
      return {
        item_id: item.product_id,
        item_name: item.product_title,
        item_variant: item.variant_title,
        item_category: item.product_type || undefined,
        quantity: item.quantity,
        price: item.final_price / 100,
        currency: getCurrency()
      };
    }

    function inferLineFromDom(el){
      const row = el.closest('[id^="CartItem-"],[id^="CartDrawer-Item-"]');
      if (!row) return null;
      const m = (row.id || '').match(/-(\d+)$/);
      return m ? Number(m[1]) : null;
    }

    function handleRemoveClick(e){
      const btn = e.target.closest('[is="cart-remove-item"],[is="gift-wrap-remove-item"]');
      if (!btn) return;

      e.preventDefault();

      const line = Number(btn.getAttribute('data-index')) || inferLineFromDom(btn) || 1;

      fetchCart()
        .then((before) => {
          const removed = before?.items?.[line - 1];
          if (!removed) return;

          const gw = getGiftWrapId();
          if (gw && Number(removed.id) === Number(gw)) return;

          const payload = {
            event: 'remove_from_cart',
            ecommerce: {
              currency: getCurrency(),
              items: [ toGaItem(removed) ]
            }
          };
          dlPush(payload);
        })
        .catch(() => {});
    }

    document.addEventListener('click', handleRemoveClick);
  })();

})();